"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePieceCombatState = void 0;
const react_1 = require("react");
const sessionContext_1 = require("~/game/sessionContext");
const usePieceCombatState = (pieceId) => {
    const { battle } = (0, sessionContext_1.useGameSession)();
    const getSnapshot = (0, react_1.useCallback)(() => {
        try {
            return battle.combatStore.getPiece(pieceId);
        }
        catch (_a) {
            return null;
        }
    }, [battle, pieceId]);
    return (0, react_1.useSyncExternalStore)(battle.combatStore.subscribe, getSnapshot);
};
exports.usePieceCombatState = usePieceCombatState;
